import { apiFetch } from '@/lib/api'
import { useRhymeStore } from '@/features/editor/useRhymeStore'

export async function labRequest(path, body, method = 'POST') {
  const res = await apiFetch(path, { method: body === undefined ? 'GET' : method, ...(body === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }) })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) { const error = new Error(data.error || data.message || 'Could not save. Try again.'); error.status = res.status; throw error }
  if (body !== undefined && /\/(recall-finish|recall-skip|activate)$/.test(path)) window.dispatchEvent(new Event('rhyme-streak-update'))
  if (body !== undefined && /\/(tasks\/[^/]+\/submit|activate)$/.test(path)) window.dispatchEvent(new Event('writing-daily-update'))
  return data
}
export const emptyDocument = () => ({ type: 'doc', content: [{ type: 'rap_line' }, { type: 'rap_line' }] })
export function nodeText(node) { return node.text ?? (node.content ?? []).map(nodeText).join('') }
export function barsIn(document) { return (document?.content ?? []).map(nodeText).map((s) => s.trim()).filter(Boolean) }
export function writingPayload(document) {
  const words = useRhymeStore.getState().words
  const occurrences = []
  ;(document?.content ?? []).forEach((line, lineIndex) => {
    let offset = 0
    ;(line.content ?? []).forEach((node) => {
      const text = nodeText(node)
      if (node.type === 'word') {
        const word = words[node.attrs?.wordId]
        const variant = word?.variants?.[word.activeVariantIndex ?? 0]
        occurrences.push({ line: lineIndex, offset, length: text.length, text, graphemes: word?.graphemes ?? text, editorWordId: node.attrs?.wordId ?? null, variantId: variant?.id ?? null, nuclei: word?.nuclei ?? node.attrs?.nuclei ?? [], pronunciation: variant?.pronunciation ?? null, syllabowls: word?.syllabowls ?? [], variant: variant ?? null, status: word?.status ?? 'unavailable' })
      }
      offset += text.length
    })
  })
  return { document, rhymeAnalysis: { version: 1, origin: 'displayed-editor-state', capturedAt: new Date().toISOString(), occurrences } }
}
export function readPending(key, fallback) { try { return JSON.parse(localStorage.getItem(key)) ?? fallback } catch { return fallback } }
export function savePending(key, value) { localStorage.setItem(key, JSON.stringify(value)) }
